<template>
  <div>
    <h1 class="page-header">{{ $t('thesisTopic.thesisTopic') }}</h1>
    <div class="row">
      <div class="col-lg-3 com-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12 overflow-auto">
        <ts-card>
          <ts-card-wrapper class="d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('Search')"
              style="width: 300px"
              class="kh-font"
            />
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-table
              :columns="columns"
              :records="resources"
              :loading="loading"
            >
              <template v-slot="{ record }">
                <td class="ts-whitespace-no-wrap">{{ record.topic_code }}</td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.topic_name_en }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.topic_name_kh }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.level ? record.level.level_name_native : '' }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.level ? record.level.level_name_foreign : '' }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{
                    record.created_by
                      ? record.created_by.employee
                        ? record.created_by.employee.name_en
                        : record.created_by.loginname
                      : ''
                  }}
                </td>
                <td class="ts-whitespace-no-wrap">{{ record.created_date }}</td>
                <td class="text-center">
                  <a
                    href="#"
                    title="edit"
                    class="text-primary mr-2"
                    @click.prevent="edit(record)"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <a
                    href="#"
                    title="delete"
                    class="text-danger"
                    @click.prevent="destroy(record.topic_id)"
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </template>
            </ts-table>
          </div>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import FormCreate from './form.vue'
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  components: {
    FormCreate
  },
  name: 'thesis-topic',
  data () {
    return {
      loading: false,
      edit_data: this.edit_data,
      columns: [
        {
          name: this.$t('thesisTopic.code')
        },
        {
          name: this.$t('thesisTopic.nameEn')
        },
        {
          name: this.$t('thesisTopic.nameKh')
        },
        {
          name: this.$t('thesisTopic.degreeKh')
        },
        {
          name: this.$t('thesisTopic.degreeEn')
        },
        {
          name: this.$t('thesisTopic.createdBy')
        },
        {
          name: this.$t('thesisTopic.createdDate')
        },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('thesisTopic', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.thesisTopic.search
      },
      set (newVal) {
        this.$store.commit('thesisTopic/SET_SEARCH', newVal)
        this.$store.commit('thesisTopic/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('thesisTopic/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    edit (record) {
      this.$store.commit('thesisTopic/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'thesis-topic-edit',
        params: { id: record.topic_id }
      })
    },
    async destroy (id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('thesisTopic/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'thesis-topic-create') {
      this.$store.commit('thesisTopic/RESET_STATE')
    }
    next()
  }
}
</script>
<style>
.scrollable {
  overflow-y: scroll;
}
</style>
